export default Object.freeze({ LOADING: 1, ERROR: 2, LOADED: 3 })
